import React from 'react';
import { getRunDateString } from '../utils/dateUtils';

const RunModal = ({ run, onClose }) => {
  if (!run) return null;

  const dateString = getRunDateString(run.date);
  const formattedDate = dateString
    ? new Date(dateString).toLocaleDateString('de-DE', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    : 'Unbekanntes Datum';

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2000,
        padding: '20px',
        boxSizing: 'border-box',
        cursor: 'pointer'
      }}
      onClick={onClose}
    >
      <div
        style={{
          maxWidth: '90%',
          maxHeight: '90%',
          backgroundColor: 'white',
          borderRadius: '12px',
          overflow: 'auto',
          cursor: 'default',
          display: 'flex',
          flexDirection: 'column'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{
          padding: '20px',
          borderBottom: '2px solid #f0f0f0',
          position: 'sticky',
          top: 0,
          backgroundColor: 'white',
          zIndex: 1
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <h2 style={{ margin: '0 0 10px 0', color: 'var(--primary)' }}>{run.name}</h2>
              <p style={{ margin: '5px 0', fontSize: '1.1rem', color: '#666' }}>
                <strong>{run.kilometers} km</strong>
              </p>
              <p style={{ margin: '5px 0', fontSize: '0.95rem', color: '#888' }}>
                {formattedDate}
              </p>
            </div>
            <button
              onClick={onClose}
              style={{
                fontSize: '2rem',
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                color: '#666',
                padding: '0 10px',
                lineHeight: 1
              }}
              aria-label="Schließen"
            >
              ×
            </button>
          </div>
        </div>

        {run.imageUrl && (
          <div style={{
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '300px'
          }}>
            <img
              src={run.imageUrl}
              alt={`Lauf von ${run.name}`}
              style={{
                maxWidth: '100%',
                maxHeight: '70vh',
                objectFit: 'contain',
                borderRadius: '8px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentElement.innerHTML = '<p style="color: #999;">Bild konnte nicht geladen werden</p>';
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default RunModal;
